<ng-container *transloco="let t">
  <nz-descriptions nzSize="small" [nzColumn]="columns">
    <nz-descriptions-item [nzTitle]="t('id')" [nzSpan]="1">
      {{ planner?.id }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('name')" [nzSpan]="1">
      {{ planner?.name }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('officeName')" [nzSpan]="1">
      {{ planner?.officeName }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('email')" [nzSpan]="1">
      <span [authorityLabsEmailLink]="planner?.email">{{
        planner?.email
      }}</span>
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('address')" [nzSpan]="1">
      {{ planner?.address }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('phone')" [nzSpan]="1">
      {{ planner?.phone }}
    </nz-descriptions-item>
  </nz-descriptions>
</ng-container>
